import { createSlice } from "@reduxjs/toolkit";

const coachLeaveReasonsSlice = createSlice({
  name: "coachLeaveReasons",
  initialState: {
    items: [],
    loaded: false, // check if already fetched once
  },
  reducers: {
    setReasons(state, action) {
      state.items = action.payload;
      state.loaded = true;
    },
    addReason(state, action) {
      state.items.push(action.payload);
    },
    updateReason(state, action) {
      const { id, label } = action.payload;
      const item = state.items.find(r => r.id === id);
      if (item) item.label = label;
    },
    removeReason(state, action) {
      state.items = state.items.filter(r => r.id !== action.payload);
    },
    clearReasons(state) {
      state.items = [];
      state.loaded = false;
    },
  },
});

export const {
  setReasons,
  addReason,
  updateReason,
  removeReason,
  clearReasons,
} = coachLeaveReasonsSlice.actions;

export default coachLeaveReasonsSlice.reducer;
